import { OPS_ENVIRON } from './todayEnviron'
import { EnvironRow, EnvironSegment } from './OpsToday.styled'

export const EnvironStrip = () => {
  const blast = OPS_ENVIRON.blastWindows[0]
  const { weather } = OPS_ENVIRON
  const weatherBad = !weather.liftsOk || !weather.roadsOk
  const lifts = weather.liftsOk ? 'lifts OK' : 'lifts suspended'
  const roads = weather.roadsOk ? 'roads OK' : 'roads closed'
  return (
    <EnvironRow>
      <EnvironSegment $tone={blast ? 'warning' : 'neutral'}>
        {blast
          ? `⚠ Blast window: ${blast.zone} closed ${blast.from}–${blast.to} — scheduler will not queue work there`
          : 'No blast windows today'}
      </EnvironSegment>
      <EnvironSegment $tone={weatherBad ? 'danger' : 'neutral'}>
        {`${weather.summary} · ${weather.tempC}°C · wind ${weather.windKmh} km/h — ${lifts}, ${roads}`}
      </EnvironSegment>
    </EnvironRow>
  )
}
